/* eslint-disable @typescript-eslint/no-explicit-any */
interface ReduceArrayProportionallyArgs {
  array: any[];
  size: number;
}

export const reduceArrayProportionally = ({ array, size }: ReduceArrayProportionallyArgs) => {
  const originalSize = array.length;

  if (originalSize <= size) {
    return [...array];
  }

  const result = [];

  for (let i = 0; i < size; i++) {
    const index = Math.round(i * ((originalSize - 1) / (size - 1)));
    result.push(array[index]);
  }

  return result;
};
